import dayjs from "utils/dayjs";

import { Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Chip from '@mui/material/Chip';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import MainCard from 'components/MainCard';
import FileDownloadIcon from 'components/FileDownloadIcon';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import AttentionObservationModal from 'components/modal/AttentionObservationModal';
import { useTranslation } from 'react-i18next';
import { writeAuditLog } from "components/axios/auditLogger";
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const AttentionObservationInfoCard = ({attentionObservation, equipmentAlert, onRefresh}) => {
    const { role, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    // const today = new Date();
    // const todayNum = dayjs(today).format("YYYYMMDD");

    // modal 관련
    const { openModal } = useModals();

    const risUserModal = (id) => {
        openModal(modals.promptModal, {
            onSubmit : (value) => {
                let body = {
                    id,
                    risUser : value
                }
                patchAttentionObservationsRelease(id, body)
                .then(async(res) => {
                    console.log(res)
                    await writeAuditLog({
                        actionType: "UPDATE",
                        targetType: "ALERT",
                        targetId: id,
                        targetName: equipmentAlert?.equipment?.equipmentNo,

                        apiUrl : `/api/attentionObservations/${id}:release`,
                        requestMethod : 'PATCH',
                        // summary: t('message.common.log.memo.alert.attentionObservation.update.release'),
                        summary: 'message.common.log.memo.alert.attentionObservation.update.release',
                        payload : body
                    });

                    onRefresh();
                })
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.release.handler.input'),
            originValue : ''
            //label : '비고'
        });
    }

    const handleObservationDelete = () => {
        console.log('주의관찰삭제')
    }

    if (attentionObservation) {
        // console.log(attentionObservation)
        let statusColor = '';
        let statusName = '';
        //console.log(endYmd);
        if (attentionObservation.status) {
            statusName = getEnumValueByEnumNameAndCode("AttentionObservationStatus", attentionObservation.status)?.[0]?.title;
            if (attentionObservation.status === 'V') {
                statusColor = "condition2";
            } else {
                statusColor = "condition4";
            }
        }

      return (
        <>
            <div className='alert_phrase'>
                <MainCard className="center_table" content={false}>
                    <div className='history_tit' style={{display: "flex", alignItems: "center", backgroundColor:"#353535"}}>
                        <div style={{marginBottom:"7px"}}>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                            <Chip label={t('message.common.btn.observe')} color="success"/>
                        </div>
                    </div>
                    
                    <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                            <TableBody>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.startYmd')}</TableCell>
                                <TableCell align="center">{attentionObservation.regYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.endYmd')}</TableCell>
                                <TableCell align="center">{attentionObservation.endYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.release.date')}</TableCell>
                                <TableCell align="center">{attentionObservation.risYmd}</TableCell>
                                {/* <TableCell className="th" align="center">주의관찰 기간</TableCell>
                                <TableCell align="center"></TableCell> */}
                            </TableRow>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.detail')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.remark}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.regUser')}</TableCell>
                                <TableCell align="center">{attentionObservation.regUser}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.createdate')}</TableCell>
                                <TableCell align="center">{attentionObservation.regYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                                <TableCell align="center">
                                    <div className={statusColor}>{statusName}</div>
                                </TableCell>
                            </TableRow>
                            {attentionObservation.risYmd && attentionObservation.risUser &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.release.handler')}</TableCell>
                                <TableCell align="center">{attentionObservation.risUser}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.release.date')}</TableCell>
                                <TableCell colSpan={3} align="center">{attentionObservation.risYmd}</TableCell>
                            </TableRow>
                            }
                            {attentionObservation.statusReport && attentionObservation.statusReport.reportDtl &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.report.detail')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.statusReport.reportDtl}
                                </TableCell>
                            </TableRow>
                            }
                            {attentionObservation.statusReport && attentionObservation.statusReport.reportFiles &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.report.file')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.statusReport.reportFiles.map(function(file, idx){
                                return (
                                <div key={idx}><FileDownloadIcon file={file} viewFileName={true}/>{(attentionObservation.statusReport.reportFiles-1)>idx && <br/>}</div>
                                )                      
                                })}
                                </TableCell>
                            </TableRow>
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </MainCard>
                <div className="btn_right">
                    <AttentionObservationModal alertId={attentionObservation.equipmentAlert.id} onRefresh={onRefresh} type="modify" />
                    {attentionObservation?.status === 'V' && 
                    <PermissionButton
                        permission={PERMISSIONS.ATTENTION_OBSERVATION_RELEASE}
                        style={{marginLeft:"3px"}}
                        variant="contained" color="error" onClick={()=>{risUserModal(attentionObservation.id)}}
                    >
                        {t('message.common.subtitle.observe.release')}
                    </PermissionButton>
                    }
                    {/* <PermissionButton
                        permission={PERMISSIONS.ATTENTION_OBSERVATION_DELETE}
                        variant="contained" color="error" style={{marginLeft:"9px"}} onClick={handleObservationDelete}
                    >
                        주의관찰삭제
                    </PermissionButton> */}
                </div>
            </div>
        </>
      )
    }
}

export default AttentionObservationInfoCard;